// extracted by mini-css-extract-plugin
module.exports = {"documents":"Regulamin_documents__2mqhB","center":"Regulamin_center__3CNzd"};